import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { Author } from '@feature/utils';

interface NoOfAuthorsProps {
  authors: Author[];
}

export function NoOfAuthors({ authors }: NoOfAuthorsProps) {
  const { t } = useTranslation();

  return (
    <Text
      size="sm"
      c="dimmed"
    >
      {authors.length} {t('articles.noOfAuthors')}
    </Text>
  );
}
